<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    class="modal-container"
    content-class="modal-large-plus"
    title="プライベートサイト設定(Type1、イントラネットFW)"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer
        v-slot="{ handleSubmit }"
        :initial-values="{ privateData: privateData }"
        as="div"
      >
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <v-row>
                  <v-col>
                    <app-label-group label="回線番号" :value="enumber" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group
                      label="サイト名"
                      :value="siteList.siteName"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group
                      label="VLAN"
                      :value="
                        siteList.vlanIdType === 'UNTAG'
                          ? 'Untag'
                          : siteList.vlanId
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <app-badge
                      item="アドレス名"
                      :msg="
                        $filter.message('info_max_length', {
                          maxLength: 20,
                        })
                      "
                      :isRequired="false"
                      placement="end"
                    ></app-badge>
                  </v-col>
                  <v-col cols="4">
                    <app-badge
                      item="アドレス"
                      :msg="
                        $filter.message(
                          'info_cidr_ip_address_of_network_address',
                          {
                            ipaddress1: '192.168.0.0/24',
                            genre: 'アドレス',
                            subnet1: '1',
                            subnet2: '30',
                            ipaddress2: '192.168.0.1/32',
                          }
                        )
                      "
                      placement="end"
                      :isRequired="
                        hasInputIpAddressName ||
                        hasCheckZone ||
                        privateData.length !== 1
                      "
                    />
                  </v-col>
                  <v-col>
                    <app-badge
                      item="ゾーン配置"
                      :isRequired="false"
                      :isInfo="false"
                    />
                  </v-col>
                </v-row>
                <validation-array
                  name="privateData"
                  v-slot="{ fields, push, remove }"
                >
                  <template v-for="(item, index) in fields" :key="item.key">
                    <v-row>
                      <v-col cols="4">
                        <validation-provider
                          label="アドレス名"
                          :name="`ipAddressName_${item.key}`"
                          v-model="privateData[index].ipAddressName"
                          :rules="{ max: { length: 20 } }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="4">
                        <validation-provider
                          label="アドレス"
                          :name="`ipAddress_${item.key}`"
                          v-model="privateData[index].ipAddress"
                          :rules="{
                            required:
                              !!privateData[index].ipAddressName ||
                              privateData[index].zoneId !== null ||
                              privateData.length !== 1,
                            is_ip_subnet: { min: 1, max: 32, exclude: [31] },
                            is_not_current_ip: true,
                            is_not_loopback_ip: true,
                            is_not_multicast_ip: true,
                            is_not_class_e_ip: true,
                            is_not_broadcast_ip: true,
                            is_network_address: true,
                            duplicate: { list: existsAddress(index) },
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                            :placeholder="
                              $filter.message(
                                'placeholder_ip_address_of_private_network_address'
                              )
                            "
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="3">
                        <app-select
                          v-model="privateData[index].zoneId"
                          :items="zoneOptions"
                          item-title="text"
                          item-value="value"
                        ></app-select>
                      </v-col>
                      <v-col cols="1" v-if="!privateData[index].isDeploy">
                        <v-btn
                          icon="$mdiMinus"
                          size="small"
                          variant="outlined"
                          class="rounded-sm"
                          @click="removeIPAddress(index, remove)"
                        />
                      </v-col>
                    </v-row>
                  </template>

                  <v-row justify="end">
                    <v-col cols="1">
                      <v-btn
                        icon="$mdiPlus"
                        size="small"
                        variant="outlined"
                        class="rounded-sm"
                        @click="addIPAddress(push)"
                      />
                    </v-col>
                  </v-row>
                </validation-array>
              </v-container>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" variant="flat" color="primary">変更</v-btn>
                <v-btn variant="outlined" color="primary" @click="cancel">
                  キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type {
  PutType1InternetAddress,
  Type1PrivateSite,
  Type1PrivateSiteModify,
  Type1Zone,
} from "@/apis/Type1SiteApi";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "PrivateSiteModify",
  props: {
    enumber: {
      type: String,
      required: true,
    },
    siteList: {
      type: Object as PropType<Type1PrivateSite>,
      required: true,
    },
    zoneList: {
      type: Array as PropType<Type1Zone[]>,
      required: true,
    },
    type1SiteZoneKeyId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      /** 詳細データ */
      privateData:
        this.siteList.addressList.length === 0
          ? [
              {
                ipAddressId: null,
                ipAddressName: "",
                ipAddress: "",
                zoneId: null,
                isDeploy: false,
              },
            ]
          : (this.siteList.addressList.map((e) => ({
              ...e,
              isDeploy: !!e.zoneId,
            })) as PutType1InternetAddress[]),
      /** ゾーン用オプション */
      zoneOptions: [
        { value: null, text: "" },
        ...this.zoneList.map((e) => ({
          value: e.zoneId,
          text: e.zoneName,
        })),
      ] as { value: string | null; text: string }[],
      /** リクエスト用データ */
    };
  },

  computed: {
    /** 既存のIPアドレス */
    existsAddress() {
      // 既存のアドレスリストに同じIPアドレスが存在した場合はエラーとする
      return (index: number) => {
        return this.privateData
          .filter((_, num) => num !== index)
          .map((v) => v.ipAddress);
      };
    },
    /** アドレス名入力済みの場合は,true */
    hasInputIpAddressName(): boolean {
      return this.privateData.some((v) => v.ipAddressName);
    },
    /** ゾーン配置選択済みの場合は,true */
    hasCheckZone(): boolean {
      return this.privateData.some((v) => v.zoneId);
    },
  },

  methods: {
    /** 変更機能 */
    async submit() {
      await this.$confirm(
        "プライベートサイト設定を変更します。よろしいですか？"
      );
      // 変更データの設定
      const reqData: Type1PrivateSiteModify = {
        site: {
          siteName: this.siteList.siteName,
          addressList:
            this.privateData.length === 1 && !this.privateData[0].ipAddress
              ? []
              : this.privateData.map((e) => ({
                  ipAddressId: e.ipAddressId,
                  ipAddressName: e.ipAddressName || null,
                  ipAddress: e.ipAddress,
                  zoneId: e.zoneId,
                })),
        },
        type1SiteZoneKeyId: this.type1SiteZoneKeyId,
      };
      await this.$api.type1SiteZone.postType1PrivateSiteModify(
        reqData,
        this.enumber,
        this.siteList.siteId
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /**
     * IPAddress追加機能
     * 押下時一行追加
     */
    addIPAddress(push: (item: any) => void) {
      const addItem = {
        ipAddressId: null,
        ipAddressName: "",
        ipAddress: "",
        zoneId: null,
        isDeploy: false,
      };
      this.privateData.push(addItem);
      push(addItem);
    },
    /**
     * IPAddress削除機能
     * 押下時その行削除
     * 一行しかない場合その行クリア
     */
    removeIPAddress(index: number, remove: (idx: number) => void) {
      if (this.privateData.length > 1) {
        this.privateData.splice(index, 1);
        remove(index);
      } else {
        this.privateData = [
          {
            ipAddressId: null,
            ipAddressName: "",
            ipAddress: "",
            zoneId: null,
            isDeploy: false,
          },
        ];
      }
    },
  },
});
</script>
<style lang="scss" scoped>
.modal-body {
  min-height: 55vh;
}
</style>
